module.exports = __webpack_public_path__ + "static/media/image-card-3.b1a4352a.png";